import { render, staticRenderFns } from "./AddBuildPhaseButton.vue?vue&type=template&id=4e271b3f"
import script from "./AddBuildPhaseButton.vue?vue&type=script&lang=ts"
export * from "./AddBuildPhaseButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports